export default {
    _prefix: "EvaluationSettings",
    labels: {
        Revisions: "Revisions",
        AllowRevisions: "Allow Revisions",
        RevisionsDescription:
            "When enabled, rescores will generate a new revision.",
        Disputes: "Disputes",
        AllowDisputes: "Allow Disputes",
        DisputesDescription:
            "When enabled, evaluations that use this form will be disputable.",
        Enabled: "Enabled",
        Disabled: "Disabled",
        DisputesPerEvaluation: "Maximum Number of Disputes Permitted",
        NextAssignee: "Next Assignee",
        PreviousEvaluatorLabel: "Assign to previous evaluator",
        PreviousEvaluatorHelp:
            "The disputed evaluation is returned to the previous evaluator for review.",
        DisputeAssignNoneLabel: "Leave unassigned",
        DisputeAssignNoneHelp:
            "The disputed evaluation is left unassigned. Process Automation is required to assign the evaluation.",
        DisputeAssignIndividualLabel: "Assign to individual",
        DisputeAssignIndividualHelp:
            "The disputed evaluation is assigned to one specified individual for review.",
        SearchDropdownDescription: "Search for a User to Select as Assignee",
        IndividualAssigneeDefault: "Type name...",
        IndividualNotSelected: "This field is required.",
        IndividualNotValid:
            "The selected user does not have the required permissions.",
        FirstDispute: "1st Dispute",
        SecondDispute: "2nd Dispute",
        ThirdDispute: "3rd Dispute",
        FourthDispute: "4th Dispute",
        FifthDispute: "5th Dispute",
        NDispute: (data: { disputeNumber: number }) =>
            `Dispute {{disputeNumber}}`,
    },
};
